import { FC } from 'react';
import { PhoneOnlyContactInfo } from './contact-info/phone-only-contact-info';
import { HeaderWrapper } from './header.styles';

export interface PhoneHeaderProps {
  phoneNumber: string;
}

export const PhoneOnlyPatientProfileHeader: FC<PhoneHeaderProps> = (props) => {
  return (
    <HeaderWrapper>
      <PhoneOnlyContactInfo phoneNumber={props.phoneNumber} />
    </HeaderWrapper>
  );
};
